@use '@konova/styles/styles' as mixins;

.root {
  @include mixins.link;

  &:hover,
  &:focus-visible {
    .typo {
      color: var(--link--color-hover);
    }
  }

  .prefix {
    margin-right: var(--theme--sizing--1x);
  }

  .typo {
    text-align: left;
  }
}
